import { Directive, ElementRef, Renderer, Input } from '@angular/core';
import { PermissionsProviderService } from '../services/permissions-provider.service';

@Directive({
  selector: '[appAuthEnable]'
})
export class AuthEnableDirective {

  @Input() authEnable: string;

  constructor(el: ElementRef, renderer: Renderer, permissionsService: PermissionsProviderService) {
    renderer.setElementStyle(el.nativeElement, 'disabled', 'disabled');
    if (this.authEnable != '') {
      var conditionExecuter = function () { renderer.setElementStyle(el.nativeElement, 'disabled', ''); };
      permissionsService.checkAuthorityAndExecuteCommand(this.authEnable, conditionExecuter, null, null);
    }
  }

}
